const COMMON_TEXT_STYLES = {
  fontFamily: 'Open Sans, sans-serif',
};

const TEXT_STYLES_BASE = {
  headingLg: {
    ...COMMON_TEXT_STYLES,
    fontSize: '36px',
    lineHeight: 1.4,
    fontWeight: 600,
    margin: '0 0 16px',
  },
  headingMd: {
    ...COMMON_TEXT_STYLES,
    fontSize: '22px',
    lineHeight: 1.4,
    fontWeight: 600,
    margin: '0 0 16px',
  },
  headingSm: {
    ...COMMON_TEXT_STYLES,
    fontSize: '16px',
    lineHeight: 1.4,
    fontWeight: 600,
    margin: '0 0 8px',
  },
  headingXs: {
    ...COMMON_TEXT_STYLES,
    fontSize: '12px',
    lineHeight: 1.4,
    fontWeight: 600,
    margin: '0 0 8px',
  },
  body: {
    ...COMMON_TEXT_STYLES,
    fontSize: '16px',
    lineHeight: 1.6,
    margin: '0 0 8px',
  },
  subtext: {
    ...COMMON_TEXT_STYLES,
    fontSize: '12px',
    lineHeight: 1.4,
    margin: '0 0 4px',
  },
};

const TEXT_STYLES = {
  ...TEXT_STYLES_BASE,
  formSectionHeading: TEXT_STYLES_BASE.headingSm,
};

const FORM_LABEL_STYLES = {
  formLabelName: {
    ...COMMON_TEXT_STYLES,
    fontSize: '14px',
    lineHeight: 1.4,
    fontWeight: 600,
    margin: '0 0 4px',
  },
  formBodyText: {
    ...COMMON_TEXT_STYLES,
    fontSize: '14px',
    lineHeight: 1.4,
    fontWeight: 400,
    margin: '0 0 4px',
  },
};

const ALL_TEXT_STYLES = {
  ...TEXT_STYLES,
  ...FORM_LABEL_STYLES,
};

export { ALL_TEXT_STYLES, TEXT_STYLES, FORM_LABEL_STYLES };
